import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { pingPresence } from '../services/api';

const PresenceHeartbeat = () => {
    const { user } = useAuth();

    useEffect(() => {
        if (!user) return;

        // Perform initial ping
        pingPresence().catch(err => console.error('Initial presence ping failed:', err));

        // Set up interval for subsequent pings (every 30 seconds)
        const interval = setInterval(() => {
            pingPresence().catch(err => console.error('Presence ping failed:', err));
        }, 30000);

        return () => {
            clearInterval(interval);
        };
    }, [user]);

    return null; // This component doesn't render anything
};

export default PresenceHeartbeat;
